<template>
  <div class="download-task">
    <div class="main-title">
      <p>{{ $t('lang.Exporting Task') }}</p>
    </div>
    <div class="main-body">
      <el-table
        :data="dataList"
        style="width: 100%;margin-bottom: 20px; border: none"
        class="table-custom"
      >
        <el-table-column :label="$t('lang.Task type')" width="300">
          <template slot-scope="{row}">
            {{ typeMap[row.bussinessType] }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('lang.Setup time')" width="200">
          <template slot-scope="{row}">
            {{$changeTime.showTime(row.createTime)}}
          </template>
        </el-table-column>
        <!--<el-table-column prop="fileName" :label="$t('lang.File name')" width="200"></el-table-column>-->
        <el-table-column :label="$t('lang.Task status')" width="200">
          <template slot-scope="{row}">
            {{ statusMap[row.status] }}
          </template>
        </el-table-column>
        <el-table-column prop="showPlacingPosition" :label="$t('lang.Download link')">
          <template slot-scope="{row}">
            <a :href="getLink(row.filePath)">{{ getLink(row.filePath) }}</a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.Operating')" width="150">
          <template slot-scope="{row}">
            <a v-if="row.filePath" class="text-btn" :href="'/' + row.filePath">{{ $t('lang.Download') }}</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-box">
        <div class="pre-btn" disabled :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">{{ $t('lang.Previous page') }}</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">{{ $t('lang.Next page') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import {getExportList} from "../api/export";

export default {
  name: 'downloadTask',
  data() {
    return {
      typeMap: {
        0: this.$t('lang.Device snapshot data export'),
        1: this.$t('lang.Export of order data for power exchange'),
        2: this.$t('lang.Export of SMS data statistics'),
        3: this.$t('lang.Sending SMS log data export'),
        4: this.$t('lang.User rights scheme export'),
        5: this.$t('lang.User battery data export'),
        6: this.$t('lang.Battery mileage data export'),
        7: this.$t('lang.Export of equipment exception records'),
        8: this.$t('lang.Abnormal export of the charging status of the charging port'),
        9: this.$t('lang.Battery idle state export'),
        10: this.$t('lang.Application for exchange order export'),
        11: this.$t('lang.Instalment order export'),
        12: this.$t('lang.Charging order export for charging cabinets'),
        13: this.$t('lang.Battery snapshot data export'),
        17: this.$t('lang.Electric vehicle information export'),
        18: this.$t('lang.Voucher information export'),
        19: this.$t('lang.Export of electricity exchange card orders'),
        20: this.$t('lang.User information export'),
        21: this.$t('lang.Return order export'),
        22: this.$t('lang.Master device information export'),
        23: this.$t('lang.Battery flow record export'),
        24: this.$t('lang.User invitation record export'),
        31: this.$t('lang.New card order export'),
        32: this.$t('lang.Renewal order export'),
        33: this.$t('lang.Swapping station management export'),
        34: this.$t('lang.Swapping order export'),
        // 35: this.$t('lang.Vehicle management export'),
        36: this.$t('lang.Electricity statistics export')
      },
      statusMap: {
        0: this.$t('lang.Pending'),
        1: this.$t('lang.In process'),
        2: this.$t('lang.Confirm'),
        3: this.$t('lang.failure'),
      },
      beginIndex: 0,
      pageSize: 10,
      dataList: [],
      preBtnDisabled: true,
      nextBtnDisabled: true,
      queryExportTaskTimer: null,
    }
  },
  computed: {
    pageIndex() {
      return Math.floor(this.beginIndex / this.pageSize) + 1;
    },
  },
  mounted() {
    this.queryExportTask();
  },
  methods: {
    async queryExportTask() {
      let params = {
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
      };
      try {
        const res = await getExportList(params)
        this.dataList = res.ldata.map(item => {
          let fileName = item.filePath.substring(item.filePath.lastIndexOf('/') + 1) || '';
          return {'fileName': fileName, ...item};
        });
        this.resetPreAndNextBtn(this.dataList.length);
      } catch (e) {
        console.log(e, 'error')
      } finally {
        if (this.$route.name === 'downloadTask') {
          this.queryExportTaskTimer && clearTimeout(this.queryExportTaskTimer);
          this.queryExportTaskTimer = setTimeout(this.queryExportTask, 3000);
        }
      }
    },
    getLink(path) {
      return path ? `${location.origin}/${path}` : '';
    },

    onPreBtnClick: function () {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex -= 1
      this.queryExportTask();
    },
    onNextBtnClick: function () {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += 1;
      this.queryExportTask();
    },
    resetPreAndNextBtn: function (length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;

  .name-label {
    float: left;
  }

  .value-label {
    display: inline-block;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    padding: 2px 8px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/downloadTask.vue